import {
  AntragsbuchFilterDto,
  CreatePolicyDto,
  IAgency,
  IFile,
  ImportedFivFile,
  IPolicy,
  IPolicyStep,
  ITask,
  PolicyFilterDto,
  UpdatePolicyDto,
  UserPolicyStatusStatsDto,
} from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';
import { ImportFivPoliciesDto } from 'admiral-core/dist/dtos/policy/import-fiv-policies.dto';

export class PolicyApi {
  static getPolicies(filter?: PolicyFilterDto): Promise<AxiosResponse<IPolicy[]>> {
    return AdmiralApi.apiCall<IPolicy[]>({
      url: `${BASE_URL}/policy/list`,
      method: 'POST',
      data: filter,
    });
  }

  static getPolicy(id: string): Promise<AxiosResponse<IPolicy>> {
    return AdmiralApi.apiCall<IPolicy>({
      url: `${BASE_URL}/policy/get`,
      method: 'POST',
      data: { id },
    });
  }

  static getPolicySteps(policyId: string): Promise<AxiosResponse<IPolicyStep[]>> {
    return AdmiralApi.apiCall<IPolicyStep[]>({
      url: `${BASE_URL}/policy/get/steps`,
      method: 'POST',
      data: { policyId },
    });
  }

  static getTasks(policyId: string): Promise<AxiosResponse<ITask[]>> {
    return AdmiralApi.apiCall<ITask[]>({
      url: `${BASE_URL}/policy/get/tasks`,
      method: 'POST',
      data: { policyId },
    });
  }

  static getFiles(policyId: string): Promise<AxiosResponse<IFile[]>> {
    return AdmiralApi.apiCall<IFile[]>({
      url: `${BASE_URL}/policy/get/files`,
      method: 'POST',
      data: { policyId },
    });
  }

  static create(newPolicyDto: CreatePolicyDto): Promise<AxiosResponse<void>> {
    const formData = new FormData();
    formData.append('body', JSON.stringify(newPolicyDto));
    newPolicyDto.newUploadedFiles.forEach((file) => formData.append('files', file));
    return AdmiralApi.apiCall<void>({
      url: `${BASE_URL}/policy/create`,
      method: 'POST',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  static update(id: string, updatePolicyDto: UpdatePolicyDto): Promise<AxiosResponse<IPolicy>> {
    const formData = new FormData();
    formData.append('body', JSON.stringify(updatePolicyDto));
    updatePolicyDto.newUploadedFiles.forEach((file) => formData.append('files', file));

    return AdmiralApi.apiCall<IPolicy>({
      url: `${BASE_URL}/policy/${id}`,
      method: 'PATCH',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  static delete(id: string): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall<void>({
      url: `${BASE_URL}/policy/${id}`,
      method: 'DELETE',
    });
  }

  static getUserPolicyStatusStats(
    userPolicyStatusStatsDto: UserPolicyStatusStatsDto,
  ): Promise<AxiosResponse> {
    return AdmiralApi.apiCall({
      url: `${BASE_URL}/policy/stats/user`,
      method: 'POST',
      data: userPolicyStatusStatsDto,
    });
  }

  static uploadFromPoliciesFiv(formData: FormData): Promise<AxiosResponse<ImportedFivFile>> {
    return AdmiralApi.apiCall<ImportedFivFile>({
      method: 'POST',
      url: `${BASE_URL}/policy/upload-from-fiv`,
      data: formData,
    });
  }
  static importFromFiv(dto: ImportFivPoliciesDto): Promise<AxiosResponse<ImportedFivFile>> {
    return AdmiralApi.apiCall<ImportedFivFile>({
      method: 'POST',
      url: `${BASE_URL}/policy/import-from-fiv`,
      data: dto,
    });
  }

  static exportPolicies(dto: PolicyFilterDto): Promise<AxiosResponse<any>> {
    return AdmiralApi.apiCall<any>({
      method: 'POST',
      url: `${BASE_URL}/policy/export`,
      data: dto,
      responseType: 'blob',
    });
  }

  static exportAntragsbuch(dto: AntragsbuchFilterDto): Promise<AxiosResponse<any>> {
    return AdmiralApi.apiCall<any>({
      method: 'POST',
      url: `${BASE_URL}/policy/antragsbuch/export`,
      data: dto,
      responseType: 'blob',
    });
  }

  static getCustomerNames(agency: IAgency): Promise<AxiosResponse<string[]>> {
    return AdmiralApi.apiCall<string[]>({
      url: `${BASE_URL}/policy/customer-names`,
      method: 'POST',
      data: { agency },
    });
  }

  static transferOpenPolicies(agency: IAgency): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall<void>({
      url: `${BASE_URL}/policy/transfer-open-policies`,
      method: 'POST',
      data: { agency },
    });
  }
}
